import { makeAutoObservable } from "mobx";
export default class MainStore {

  constructor() {
    makeAutoObservable(this);
  }

  //General
  systemDomain = process.env.REACT_APP_SERVER_URL;
  lang = "";
  menuNo = 0;
  menuType = 0;

  isMobileMenuOpen = false;

  setLang = (l) => {
    this.lang = l;
  };

  setMenuType = (tk) => {
    this.menuType = tk;
  };

  setMenuNo = (tk) => {
    this.menuNo = tk;
  };


  //Top MenuType
  SettingsDashboardMenuType = 100;
  SettingsDashboardMenuNo = 100;

  HomeMenuType = 200;
  HomeMenuNo = 200;

  ToolsCatalogMenuType = 200;
  ToolsCatalogMenuNo = 201;

  // FacilityDashboardMenuType = 700;
  // FacilityDashboardMenuNo = 700;

  //Settings MenuType-> 100 

  RoleMenuType = 100;
  RoleMenuNo = 101;

  UserMenuType = 100;
  UserMenuNo = 102;

  UserApprovalMenuType = 100;
  UserApprovalMenuNo = 103;

  ContentApprovalMenuType = 100;
  ContentApprovalMenuNo = 104;

  // Content Management Admin Menu Items (under Administration)
  ResearchPublicationsAdminMenuType = 100;
  ResearchPublicationsAdminMenuNo = 110;

  ResearchTeamAdminMenuType = 100;
  ResearchTeamAdminMenuNo = 111;

  PlatformHistoryAdminMenuType = 100;
  PlatformHistoryAdminMenuNo = 112;

  SystemVersionsAdminMenuType = 100;
  SystemVersionsAdminMenuNo = 113;

  KeyFeaturesAdminMenuType = 100;
  KeyFeaturesAdminMenuNo = 114;

  MCDMMethodsAdminMenuType = 100;
  MCDMMethodsAdminMenuNo = 115;

  // User submission menu items
  UserSubmissionMenuType = 600;
  UserSubmissionMenuNo = 601;

  SubmitToolPassportMenuType = 600;
  SubmitToolPassportMenuNo = 609;

  SubmitCriteriaMenuType = 600;
  SubmitCriteriaMenuNo = 603;

  SubmitToolFeatureMenuType = 600;
  SubmitToolFeatureMenuNo = 604;

  MySubmissionsMenuType = 600;
  MySubmissionsMenuNo = 602;

  MyToolsMenuType = 600;
  MyToolsMenuNo = 605;

  MyRequestsMenuType = 600;
  MyRequestsMenuNo = 606;

  MyCriteriaMenuType = 600;
  MyCriteriaMenuNo = 607;

  MyToolFeaturesMenuType = 600;
  MyToolFeaturesMenuNo = 608;

  PanelMenuType = 300;
  PanelMenuNo = 305;

  CategoryMenuType = 300;
  CategoryMenuNo = 306;

  SubcategoryMenuType = 300;
  SubcategoryMenuNo = 307;

  TypeOfToolMenuType = 300;
  TypeOfToolMenuNo = 308;

  ToolPassportMenuType = 300;
  ToolPassportMenuNo = 309;

  CriteriaMenuType = 400;
  CriteriaMenuNo = 410;

  CriteriaValueMenuType = 400;
  CriteriaValueMenuNo = 411;

  ToolFeatureMenuType = 400;
  ToolFeatureMenuNo = 412;

  
  ToolSelectionMenuType = 400;
  ToolSelectionMenuNo = 413;

  // Add CriteriaManagerMenuNo and CriteriaManagerMenuType
  CriteriaManagerMenuNo = 4030;
  CriteriaManagerMenuType = 400;

  // Research Menu Type -> 500
  ResearchMenuType = 500;
  ResearchMenuNo = 500;

  // Method Comparison (under Research)
  MethodComparisonMenuType = 500;
  MethodComparisonMenuNo = 501;

}
